export default interface Translatable {
    language: Language;
}

export enum Language {
    English,
    Swedish
}